import $ from "jquery";

let listEl = $(".advisor-list");

let filter = {
  region: -1,
  page: 1
};

$(function () {
  listEl.each(function () {
    advisorList($(this));
  });

  $('.county_advisor').on('mouseenter', function () {
        $(this).addClass('active');

        var sizeY = $('.advisors__map_hover').height();
        var sizeX = $('.advisors__map_hover').width();

        var pathY = this.getBoundingClientRect().height;
        var pathX = this.getBoundingClientRect().width;

        var posY = $(this).offset().top - sizeY + pathY / 2 - 30;
        var posX = $(this).offset().left - (sizeX - pathX) / 2;

        $('.advisors__map_hover').css({
            top: posY,
            left: posX,
        });

        var href = $(this).parent().attr('href');
        var regionId = $(this).parent().data('id');
        $('.advisors__map_hover').attr('href', href);
        $('.advisors__map_hover ' + regionId).addClass('active');
        $('.advisors__map_hover').addClass('active');

        regionId = $(this).data('region');
        $(`.advisors__link[data-region=${regionId}]`).addClass('active');
    });

    $('.county_advisor').on('mouseleave', function () {
        if ($('.advisors__map_hover').filter(':hover').length == 0) {
            $('.advisors__map_hoverData.active').removeClass('active');
            $('.advisors__map_hover').removeClass('active');
            $(this).removeClass('active');
            $('.advisors__link').removeClass('active');
        }
    });

    $('.advisors__map_hover').on('mouseleave', function () {
        $('.advisors__map_hoverData.active').removeClass('active');
        $('.advisors__map_hover').removeClass('active');
        $('.county_advisor.active').removeClass('active');
        $('.advisors__link').removeClass('active');
    });

    $('.advisors__link').on('mouseenter', function () {
        var regionId = $(this).data('region');
        $(`.county_advisor[data-region=${regionId}]`).addClass('active');
    });

    $('.advisors__link').on('mouseleave', function () {
      $('.county_advisor.active').removeClass('active');
  });

    $('.advisors__link').on('click', async function () {
        filter.region = $(this).data("region");
        filter.page = 1;

        $('.advisors__link').removeClass('filtered');
        $(`.advisors__link[data-region=${filter.region}]`).addClass('filtered');
        
        $('.county_advisor').removeClass('filtered');
        $(`.county_advisor[data-region=${filter.region}]`).addClass('filtered');

        const data = await getAdvisors(filter);  
        $("#advisor-list").html(data.html);
    });

    $('.advisors__map_hoverData').on('click', async function () {
        filter.region = $(this).data("region");
        filter.page = 1;
        
        $('.advisors__link').removeClass('filtered');
        $(`.advisors__link[data-region=${filter.region}]`).addClass('filtered');
        
        $('.county_advisor').removeClass('filtered');
        $(`.county_advisor[data-region=${filter.region}]`).addClass('filtered');

        const data = await getAdvisors(filter);  
        $("#advisor-list").html(data.html);
    });
});


const advisorList = (listEl) => { 
    bindAdvisorsButtons(listEl, filter);
};

const reRenderList = async (element, filter, append = false) => {  
  const data = await getAdvisors(filter);
  if (append === true) {
    $("#advisor-list").append(data.html);  
  } else {
    $("#advisor-list").html(data.html);
  }
};

const bindAdvisorsButtons = (element, filter) => {
    element.on("click", ".advisor-list__more_button", function () {
      filter.page++;
      reRenderList(element, filter, true);
      $(this).parent().remove();
    });
  
  }

const getAdvisors = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + `/wp-json/nzu/v1/advisor-list/html`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};

